import { useI18n } from "@/i18n/I18nProvider";

const TRIPARTITE = [
    {
        n: 1,
        eyebrowKey: "forwhonew.p1.eyebrow",
        titleKey: "forwhonew.p1.title",
        bodyKey: "forwhonew.p1.body",
        listKey: "forwhonew.p1.list",
        accent: "var(--itly-orange-500)",
        bg: "var(--itly-peach-050)",
        glyph: "→",
    },
    {
        n: 2,
        eyebrowKey: "forwhonew.p2.eyebrow",
        titleKey: "forwhonew.p2.title",
        bodyKey: "forwhonew.p2.body",
        listKey: "forwhonew.p2.list",
        accent: "var(--itly-fg-strong)",
        bg: "var(--itly-teal-050)",
        glyph: "✧",
    },
    {
        n: 3,
        eyebrowKey: "forwhonew.p3.eyebrow",
        titleKey: "forwhonew.p3.title",
        bodyKey: "forwhonew.p3.body",
        listKey: "forwhonew.p3.list",
        accent: "#4E7F65",
        bg: "var(--itly-surface-green)",
        glyph: "▲",
    },
];

function ForWhoCard({ t, c }) {
    return (
        <article
            key={c.n}
            data-testid={`forwho-p${c.n}`}
            style={{
                background: "var(--itly-surface)",
                borderRadius: 20,
                border: "1px solid var(--itly-border)",
                boxShadow: "var(--itly-card-shadow)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                aria-hidden="true"
                style={{
                    background: c.bg,
                    padding: "22px 24px 18px",
                    borderBottom: "1px solid var(--itly-border)",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                }}
            >
                <span
                    style={{
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        background: "var(--itly-surface)",
                        color: c.accent,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "Fraunces, serif",
                        fontSize: 20,
                        fontWeight: 600,
                        border: `1px solid ${c.accent}`,
                    }}
                >
                    {c.glyph}
                </span>
                <div>
                    <div
                        style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: 11,
                            letterSpacing: "0.14em",
                            textTransform: "uppercase",
                            color: c.accent,
                            fontWeight: 700,
                            marginBottom: 4,
                        }}
                    >
                        {t(c.eyebrowKey)}
                    </div>
                    <h3
                        style={{
                            fontFamily: "Fraunces, serif",
                            fontSize: 24,
                            lineHeight: 1.15,
                            color: "var(--itly-fg-strong)",
                            margin: 0,
                            letterSpacing: "-0.005em",
                        }}
                    >
                        {t(c.titleKey)}
                    </h3>
                </div>
            </div>
            <div style={{ padding: "22px 24px 26px", flex: 1, display: "flex", flexDirection: "column", gap: 14 }}>
                <p
                    style={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: 14.5,
                        lineHeight: 1.6,
                        color: "var(--itly-muted)",
                        margin: 0,
                    }}
                >
                    {t(c.bodyKey)}
                </p>
                <div
                    style={{
                        marginTop: "auto",
                        padding: "10px 12px",
                        background: "var(--itly-cream)",
                        borderRadius: 10,
                        fontFamily: "Inter, sans-serif",
                        fontSize: 12.5,
                        color: "var(--itly-fg-strong)",
                        fontWeight: 500,
                        lineHeight: 1.5,
                    }}
                >
                    {t(c.listKey)}
                </div>
            </div>
        </article>
    );
}

export default function ForWho() {
    const { t } = useI18n();
    return (
        <section
            id="per-chi"
            data-testid="for-who"
            data-reveal="up"
            style={{
                position: "relative",
                background: "var(--itly-surface)",
                borderTop: "1px solid var(--itly-border)",
                borderBottom: "1px solid var(--itly-border)",
                padding: "96px 32px",
            }}
        >
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 48 }}>
                    <div className="itly-badge">{t("forwhonew.badge")}</div>
                    <h2
                        style={{
                            fontFamily: "Fraunces, serif",
                            fontSize: "clamp(32px, 4vw, 52px)",
                            lineHeight: 1.05,
                            color: "var(--itly-fg-strong)",
                            marginTop: 20,
                            marginBottom: 18,
                            letterSpacing: "-0.01em",
                        }}
                    >
                        {t("forwhonew.title_a")}{" "}
                        <em style={{ color: "var(--itly-orange-500)", fontStyle: "italic" }}>
                            {t("forwhonew.title_b")}
                        </em>
                    </h2>
                    <p
                        style={{
                            maxWidth: 660,
                            margin: "0 auto",
                            fontFamily: "Inter, sans-serif",
                            fontSize: 16,
                            lineHeight: 1.65,
                            color: "var(--itly-muted)",
                        }}
                    >
                        {t("forwhonew.sub")}
                    </p>
                </div>

                <div
                    className="itly-forwho-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                        gap: 22,
                    }}
                >
                    {TRIPARTITE.map((c) => <ForWhoCard key={c.n} t={t} c={c} />)}
                </div>
            </div>
        </section>
    );
}
